module.exports = __webpack_public_path__ + "img/c665177.jpg";